<template>
  <div class="page-container">
    <div class="back_left" @click="$router.go(-1)" />
    <!-- <div class="big_tit">
        {{ $t('safe.setting') }}
      </div> -->
  </div>
</template>

<script>
export default {
  data() {
    return {
      formData: {
        name: '',
        cardNumber: '',
        cardImage: null
      },
      previewImage: null
    }
  },
  created() {
    this.$parent.footer('user', false);
  },
  methods: {
    handleFileUpload(event) {
      const file = event.target.files[0]
      if (file) {
        this.formData.cardImage = file
        this.previewImage = URL.createObjectURL(file)
      }
    },
    handleSubmit() {
      console.log('提交解绑:', this.formData)
      alert('解绑申请已提交')
    }
  }
}
</script>

<style lang="less" scoped>
.page-container {
  height: 100vh;
  background: url(../images/user/hongtext.jpg) no-repeat center;
  background-size: 112% 102%;
  position: relative;
  // height: 100vh;
}

.headers {
  color: #ffd08e;
  font-size: 24px;
  position: absolute;
  top: 10%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  text-align: center;
}

.form-wrapper {
  position: absolute;
  top: 55%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 80%;
  max-width: 500px;
  background: #fff;
  padding: 0 30px 30px;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.card-form h2 {
  text-align: center;
  margin-bottom: 20px;
}

.form-title {
  width: 200px;
  margin: 0 auto 10px;
  background: #d7000f;
  color: #fff;
  border-radius: 0 0 12px 12px;
  padding: 8px 0;
  font-size: 16px;
  text-align: center;
  margin-bottom: 18px;
  font-weight: bold;
}

.form-group {
  margin-bottom: 20px;
  // display: flex;
  // justify-content: space-around;
  // align-items: center;
}

label {
  display: block;
  margin-bottom: 8px;
}

input {
  width: 100%;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
}

.preview img {
  max-width: 100%;
  max-height: 200px;
  margin-top: 10px;
}

.confirm-btn {
  position: absolute;
  bottom: 170px;
  width: 80%;
  max-width: 500px;
  left: 50%;
  transform: translateX(-50%);
  padding: 12px 40px;
  background: #ffdf9a;
  color: red;
  border: none;
  border-radius: 4px;
  font-size: 18px;
  font-weight: bold;
  cursor: pointer;
}

.confirm-text {
  font-weight: bold;
  position: absolute;
  bottom: 120px;
  left: 50%;
  transform: translateX(-50%);
  text-align: center;
  display: flex;
  flex-direction: column;
  width: 80%;
  font-size: 15px;
  color: #fff;
}

.add-card {
  display: block;
  width: 100%;
  height: 150px;
  line-height: 150px;
  background: #fff0e0;
  color: #d7000f;
  border: 1px dashed #d7000f;
  border-radius: 6px;
  font-size: 15px;
  text-align: center;
  margin-bottom: 12px;
  cursor: pointer;
}

.tip {
  color: #d7000f;
  font-size: 12px;
  text-align: center;
  margin-top: 8px;
  margin-bottom: 10px;
}
.imggw{
  position: absolute;
    top: 18%;
    left: 50%;
    transform: translateX(-50%);
}
</style>